import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://supabase.goal-archive.net',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzc5Mzg5Mjk4LCJleHAiOjE5MzcwNjkyOTh9.BTnmwFKrwX-iMac0jAHzZKBNBSSrSKcF38vYs9VR65o',
  {
    auth: {
      // PKCE instead of the implicit flow: signup-confirmation and
      // password-reset emails now carry a one-time `?code=` that can only be
      // exchanged for a session by the browser that originally requested it
      // (the matching code_verifier lives in that browser's localStorage).
      // Under the old implicit flow the email link itself carried a live
      // access/refresh token, so anyone who opened the link — not just the
      // account owner — was signed in as them.
      flowType: 'pkce',
    },
  }
)
